//#region Imports
import { Injectable } from '@angular/core';
import { MemberResponseHelper } from '../shared/member-response-helper';
import { SurveyResponseDto } from '../model/surveyResponseDto';
import { SurveySummaryDto } from '../model/surveySummaryDto';
//#endregion Imports
@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
    //#region Constructor
    //#endregion Constructor

    //#region Private properties
    private readonly KeyQueueLetterId: string = 'QueueLetterId';
    private readonly KeyReferenceNumber: string = 'ReferenceNumber';
    private readonly keySurveyResponse: string = 'SurveyResponse';
    private readonly keyActiveSurveyStepindex: string = 'ActiveSurveyStepindex';
    private readonly keyAccessToken: string = 'AccessToken';
    private readonly keySurveySummary: string = 'SurveysSummary';
    //#endregion Private properties

    //#region Public properties
    //QueueLetterId
    public SaveQueueLetterId(id: number) : void {
        sessionStorage.setItem(this.KeyQueueLetterId, id.toString());
    }

    public SaveReferenceNumber(referenceNumber : string) : void {
        sessionStorage.setItem(this.KeyReferenceNumber, referenceNumber);
    }

    public GetQueueLetterId() : number {
        const id: string = sessionStorage.getItem(this.KeyQueueLetterId);
        return id ? Number(id): null;
    }

    public GetReferenceNumber() : string {
        return sessionStorage.getItem(this.KeyReferenceNumber);
    }

    //SurveyResponse
    public SaveSurveyResponse(surveyResponse: SurveyResponseDto) : void{
        sessionStorage.setItem(this.keySurveyResponse, JSON.stringify(surveyResponse));
    }

    public GetSurveyResponse() : SurveyResponseDto{
        const surveyResponseString: string = sessionStorage.getItem(this.keySurveyResponse);
        return MemberResponseHelper.Deserialize<SurveyResponseDto>(surveyResponseString);
    }

    //SurveySummary
    public SaveSurveySummary(surveySummary: SurveySummaryDto): void{
        sessionStorage.setItem(this.keySurveySummary, JSON.stringify(surveySummary));
    }

    public GetSurveysummary(): SurveySummaryDto{
        const surveySummaryString: string = sessionStorage.getItem(this.keySurveySummary);
        return MemberResponseHelper.Deserialize<SurveySummaryDto>(surveySummaryString);
    }

    //Active Survey Step Index
    public SaveActiveSurveyStepIndex(index: number) : void{
        sessionStorage.setItem(this.keyActiveSurveyStepindex, index.toString());
    }

    public GetActiveSurveyStepIndex() : number {
        const index: string = sessionStorage.getItem(this.keyActiveSurveyStepindex);
        return index ? Number(index): 0;
    }

    //Delete Session
    public DeleteSession() : void {
        sessionStorage.clear();
    }

    public SaveToken(token: string): void {
        sessionStorage.setItem(this.keyAccessToken, token);
    }

    public GetToken(): string | null {
        return sessionStorage.getItem(this.keyAccessToken);
    }
    //#endregion Public properties
}
